
export default {
  data() {
    return {
      forms: [],
      formId: 0,
      secondFormId: 0,
      thirdFormId: 0,
      formData: [],
      pageData: null,
      selectedForms: [],

      activeContactIndex: 0,

      options: [
        {
          name: "logo",
          label: "Logo",
          type: "image",
          size: "50x50",
        },
        {
          name: "text",
          label: "Tekst",
          type: "text",
        },
      ],
    };
  },
  watch: {
    $isInEditMode(v) {
      this.getAllForms();
    },
  },
  mounted() {
    this.getPageData();

    if (this.$isInEditMode) {
      this.getAllForms();
    }
  },
  methods: {
    returnConsentText(index) {
      switch (index) {
        case 0:
          return "tvrtke Gauss";
          break;
        case 1:
          return "Gimnazije Gaudeamus";
          break;
        case 2:
          return "tvrtke VRGR8";
          break;
        default:
          return "Privola";
      }
    },

    setActiveContact(index) {
      this.activeContactIndex = index;

      const element = document.getElementById("forms");
      if (element) {
        element.scrollIntoView();
      }
    },

    getPageData() {
      if (
        this.$parent &&
        this.$parent.$parent &&
        this.$parent.$parent.pageData
      ) {
        this.pageData = this.$parent.$parent.pageData;

        if (
          this.pageData &&
          this.pageData.components &&
          this.pageData.components.length
        ) {
          this.pageData.components.forEach((data) => {
            if (data && data.linkMeta && data.linkMeta.formId) {
              this.formId = parseInt(
                data.linkMeta.formId.replace(/(<([^>]+)>)/gi, "")
              );
            }

            // second form
            if (data && data.linkMeta && data.linkMeta.secondFormId) {
              this.secondFormId = parseInt(
                data.linkMeta.secondFormId.replace(/(<([^>]+)>)/gi, "")
              );
            }

            // third form
            if (data && data.linkMeta && data.linkMeta.thirdFormId) {
              this.thirdFormId = parseInt(
                data.linkMeta.thirdFormId.replace(/(<([^>]+)>)/gi, "")
              );
            }

            this.getForms();
          });
        }
      }
    },

    async getAllForms() {
      const body = {
        customConfig: {},
        filters: [],
        limit: 100,
        list: true,
        offset: 0,
        page: 1,
      };
      try {
        const data = await this.$axios.post(
          "/api/v1/cms/form/filter?gBoxList=true",
          body
        );
        if (data) {
          this.forms = data.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async getForms() {
      const id1 = this.formId;
      const id2 = this.secondFormId;
      const id3 = this.thirdFormId;

      try {
        const data1 = await this.$axios.get("/api/v1/cms/form/get/" + id1);
        if (data1 && data1.data && data1.data.data) {
          this.selectedForms.push(data1.data.data);
        }

        const data2 = await this.$axios.get("/api/v1/cms/form/get/" + id2);
        if (data2 && data2.data && data2.data.data) {
          this.selectedForms.push(data2.data.data);
        }

        const data3 = await this.$axios.get("/api/v1/cms/form/get/" + id3);
        if (data3 && data3.data && data3.data.data) {
          this.selectedForms.push(data3.data.data);
        }
      } catch (e) {
        console.log(e);
      }
    },

    setFormInputs(form, field) {
      if (!form) return;

      if (this.formData[field.key]) {
        form[field.key] = this.formData[field.key];
      } else {
        form[field.key] = null;
      }
    },
  },
};
